// sagas/index.ts
import { all } from 'redux-saga/effects';
import watchBlocksActions from './blocksSaga'; // Import your blocks saga

export default function* rootSaga() {
    yield all([
        watchBlocksActions(), // Add other sagas here
    ]);
}
